/**
 * @fileoverview AR-924 — Date helpers of the teacher deliverable drawer: backend ISO days (`YYYY-MM-DD`)
 * to locale numeric / long / date-time strings and back.
 */

const ISO_DAY = /^\d{4}-\d{2}-\d{2}$/

/** Noon avoids the day shifting across timezones when a plain ISO day is parsed. */
function parseIsoDay(value: string): Date | null {
  if (!value) return null
  const isPlainIsoDay = ISO_DAY.test(value)
  const date = isPlainIsoDay ? new Date(`${value}T12:00:00`) : new Date(value)
  return Number.isNaN(date.getTime()) ? null : date
}

export function toIsoDay(date: Date): string {
  const year = date.getFullYear()
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const day = String(date.getDate()).padStart(2, '0')
  return `${year}-${month}-${day}`
}

export function fromIsoDay(value: string | null | undefined): Date | null {
  return value ? parseIsoDay(value) : null
}

export function formatNumericDate(value: string | null | undefined, locale: string): string {
  const date = fromIsoDay(value)
  if (!date) return value ?? ''
  return date.toLocaleDateString(locale, { day: '2-digit', month: '2-digit', year: 'numeric' })
}

export function formatLongDate(value: string | null | undefined, locale: string): string {
  const date = fromIsoDay(value)
  if (!date) return value ?? ''
  return date.toLocaleDateString(locale, { day: 'numeric', month: 'short', year: 'numeric' })
}

export function formatDateTime(value: string | null | undefined, locale: string): string {
  const date = fromIsoDay(value)
  if (!date) return value ?? ''
  return date.toLocaleString(locale, {
    day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit',
  })
}

export function dateInputFormat(locale: string): string {
  return locale.toLowerCase().startsWith('en') ? 'MM/DD/YYYY' : 'DD/MM/YYYY'
}
